import './WhyUs.scss';
import bg from '../../images/why-us.jpg';

import { FaUsers, FaHome, FaDollarSign, FaMapMarkedAlt } from 'react-icons/fa';

export default function WhyUs() {

  const data = [
    { title: "Trusted By Thousands", icon: <FaUsers /> },
    { title: "Wide Range Of Properties", icon: <FaHome /> },
    { title: "Financing Made Easy", icon: <FaDollarSign /> },
    { title: "See Neighborhoods", icon: <FaMapMarkedAlt /> }
  ];

  return (
    <section
      className="why"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="overlay-why">

        <div className="content-center">
          <h2>Why Choose Us</h2>
          <p>We provide full service at every step</p>
        </div>

        <div className="container">
          <div className="grid-why">
            {data.map((item, i) => (
              <div key={i} className="box">
                <div className="icon">{item.icon}</div>
                <h3>{item.title}</h3>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}